import { getDocument } from './get-document';
import { requestAnimationFrameAsync } from './request-animation-frame-async';

// TODO
// Provide a default width when run in server.
// Is needed to detect different browsers?

/**
 * Helper for getting width of browser native scroll bar.
 * NOTE: If in server environment, returns `0`.
 *
 * @public
 */
export function getScrollBarWidth(): number {
  const doc = getDocument();
  if (!doc) {
    return 0;
  }

  const element = createElementWidthScrollBar(doc);
  document.body.appendChild(element);
  const width = element.offsetWidth - element.clientWidth;
  document.body.removeChild(element);
  return width;
}

/**
 * Helper for getting width of browser native scroll bar asynchronously via requestAnimationFrame optimization.
 * NOTE: If in server environment, returns `0`.
 *
 * @public
 */
export async function getScrollBarWidthAsync(): Promise<number> {
  return requestAnimationFrameAsync(getScrollBarWidth);
}

/**
 * Helper for creating a hidden element bar for getting scroll bar width.
 * @param doc The `document` object.
 *
 * @internal
 */
function createElementWidthScrollBar(doc: Document): HTMLElement {
  const element = doc.createElement('div');
  element.style.cssText = `position:absolute;top:-99px;left:-99px;width:99px;height:99px;overflow:scroll;opacity:0;pointer-events:none;`;
  return element;
}
